import React, { ReactElement } from 'react';

import { GlobalConfig } from '@digital-dealer/brand-theming';
import { configurationService } from '@digital-dealer/configuration-service';
import { textsService } from '@digital-dealer/texts-service';

import RoutingRules from './routingRules';
import configOverride from './configs/configOverride';
import textsOverride from './configs/textsOverride';

configurationService.override(configOverride);
textsService.override(textsOverride);

const App = (): ReactElement => (
  <GlobalConfig>
    <RoutingRules />
  </GlobalConfig>
);

export default App;
